var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import * as S from './styled';
var Button = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'large' : _b, _c = _a.bType, bType = _c === void 0 ? 'action' : _c, // we cannot use the type attribute in this component because it's the global property of button
    _d = _a.rounded, // we cannot use the type attribute in this component because it's the global property of button
    rounded = _d === void 0 ? false : _d, _e = _a.animation, animation = _e === void 0 ? true : _e, _f = _a.loading, loading = _f === void 0 ? false : _f, Icon = _a.Icon, children = _a.children, rest = __rest(_a, ["size", "bType", "rounded", "animation", "loading", "Icon", "children"]);
    return (
    // @ts-ignore
    <S.StyledButton bType={bType} size={size} rounded={rounded} hasIcon={!!Icon} animation={animation} {...rest}>
            <S.Wrapper>
                {loading
            ? (<S.StyledThrobber color={['primary', 'action', 'accent'].includes(bType)
                    ? COLORS.TextWhite
                    : COLORS.ButtonAccent} isLoading={true}/>)
            : (<>
                            {Icon}
                            {children}
                        </>)}
            </S.Wrapper>
        </S.StyledButton>);
};
export default styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
